import { AppContext } from "@lightspeed-invoicing/core-client/frontend"
import { HttpError, isError, newHttpError } from "../helpers/Error"
import HttpClient from "../helpers/HttpClient"
import Fee, { FeeDto } from "./Fee"

class FeeService {
    static httpClient = new HttpClient<Fee, FeeDto>(Fee)

    static async RetrieveExternalShippingMethods(integrationKey: string): Promise<[] | HttpError> {
        const res = await AppContext.getApiClient().get(`/${integrationKey}/external-shipping-methods`)
        if (res.error) {
            return newHttpError(res.error.message, res.error)
        }
        return res.data
    }

    static async get(): Promise<Fee | Fee[] | HttpError> {
        const res = await this.httpClient.get("/fees")
        return res
    }


    static async create(payload: object, feeType: string): Promise<Fee | HttpError> {
        const res = await this.httpClient.post(`/fees/${feeType}`, payload)
        if (isError(res)) {
            return res as HttpError
        }
        return res as Fee
    }

    static async update(payload: object, feeId: string): Promise<Fee | HttpError> {
        const res = await this.httpClient.patch(`/fees/${feeId}`, payload)
        if (isError(res)) {
            return res as HttpError
        }
        return res as Fee
    }

    static async delete(feeId: string): Promise<Fee | HttpError> {
        const res = await this.httpClient.delete(`/fees/${feeId}`)
        if (isError(res)) {
            return res as HttpError
        }
        return res as Fee
    }

    static async applyFee(props, feeInputs): Promise<HttpError | undefined> {
        const res = await this.httpClient.patch(getEndPoint(props), { [getField(props)]: feeInputs })
        if (isError(res)) {
            return res as HttpError
        }
    }

    static async setFeeAsDefault(feeId: string, feeType: string): Promise<Fee | HttpError> {
        const res = await this.httpClient.put(`/fees/${feeId}/default/${feeType}`, {})
        if (isError(res)) {
            return res as HttpError
        }
        return res as Fee
    }

}

export default FeeService

type fieldParameter = {
    billingMethod: string
}
function getField(props: fieldParameter): string {
    let field = "feeIds"
    switch (props.billingMethod) {
    case "monthly":
        field = "monthlyFeeIds"
        break
    case "yearly":
        field = "yearlyFeeIds"
        break
    }
    return field
}

type endpointParameter = {
    invoiceId?: string
    quoteId?: string
    mainObject?: string
    objectId?: string
    pricingTableId?: string
}

function getEndPoint(props: endpointParameter): string {
    if (props.invoiceId) {
        return `/invoices/${props.invoiceId}`
    }
    if (props.quoteId) {
        return `/quotes/${props.quoteId}`
    }
    if (props.pricingTableId) {
        return `/pricing-tables/${props.pricingTableId}`
    }
    return `/${props.mainObject}/${props.objectId}`
}



// WEBPACK FOOTER //
// ./src/state/fee/FeeService.ts